import React from 'react';
import { hasAccessRights, truncateString } from '../../../../../shared/functions/Functions';
import { IContract } from '../../../../../model/shared/IContract';
import { CustomImageHandler } from '../../../../../shared/components/CustomImageHandler';
import { priceSplitter } from '../../../../../utils/helpers/priceSplitter';
import { numberFormatter } from '../../../../../utils/helpers/numberFormater';
import { AccessRightEnum } from '../../../../../enum/AccessRightEnum';
import TooltipOverlay from '../../../../../shared/components/tooltip/Tooltip';

interface IDashboardContractListItemProps {
    contract: IContract;
}

export function DashboardContractListItem({ contract }: IDashboardContractListItemProps) {
    const name = !!contract?.user?.displayName
        ? contract?.user?.displayName
        : contract?.user?.firstName + ' ' + contract?.user?.lastName;
    const truncatedName = truncateString(name, 25);
    const isTruncated = name.length > 25;
    return (
        <>
            <tr>
                <td className="text-start">
                    <div className="d-flex align-items-center">
                        <CustomImageHandler
                            classes="user-img-rounded mr-2"
                            photoPath={contract?.user?.profilePhoto?.thumbnail}
                            altTag="User Photo"
                            name={name}
                        />
                        <TooltipOverlay content={isTruncated ? name : ''}>
                            <p className="mb-0">{truncatedName || '-'}</p>
                        </TooltipOverlay>
                    </div>
                </td>
                <td className="text-center">
                    {contract?.postingsUsed ?? '-'}/{contract?.nbPosts ?? '-'}
                </td>
                <td className="text-center">{contract?.nbPosts ?? '-'}</td>
                <td className="text-center">{numberFormatter(contract?.user?.totalFollowers ?? 0)}</td>
                <td className="text-center">{numberFormatter(contract?.user?.totalReach ?? 0)}</td>
                <td className="text-center">{priceSplitter(contract?.avgER ?? 0)}</td>
                {!hasAccessRights(AccessRightEnum.MEASURE_HIDE_COSTS) && (
                    <>
                        <td className="euro-symbol text-center">{priceSplitter(contract?.avgCpmReach ?? 0)}</td>
                        <td className="euro-symbol text-end">
                            {contract?.price ? priceSplitter(contract?.price) : '0'}
                        </td>
                    </>
                )}
            </tr>
        </>
    );
}
